import * as React from 'react';
import withPaddingAndMargin from '../withPaddingAndMargin';

var Chip = function Chip(props) {
  var size = props.size ? 'dd-chip-' + props.size : 'dd-chip-md';
  var color = props.color ? 'dd-chip-' + props.color : 'dd-chip-default';
  return React.createElement('div', {
    className: 'dd-chip ' + size + ' ' + color + ' ' + props.className
  }, props.children);
};

export default withPaddingAndMargin(Chip);